export default __webpack_public_path__ + "static/media/fanfare.8807360a.mp3";